import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class EnvironmentService {
  public isDev(): boolean {
    const { hostname } = location;

    return hostname.includes("XXXXXXX");
    // return hostname.includes("dev-3") || hostname === "localhost";
  }

  public isProduction(): boolean {
    const { hostname } = location;

    return hostname === "www.brightfunded.com" || hostname === "brightfunded.com";
  }

  public getHostname(): string {
    const { hostname } = location;

    return hostname;
  }
}
